<template>
  <div>
    <div style="position: absolute; top: 10; left; 10" id="backButton">
      <font-awesome-icon @click="goRouter('/sportsengine')" class="menuIcon" icon="arrow-left" />
    </div>
    <div><h1 class="title is-3">Delete Games from SportsEngine</h1></div>
    <div v-if="!schedules.length">
      No schedules currently synced to SportsEngine!
      <br />
      <br />
      <Button label="Go to Schedules" @click="goRouter('/schedules')" />
    </div>
    <div v-else class="importHeader">Choose Schedule to Delete Games from SE</div>
    <div
      v-for="s in schedules"
      :key="s.id"
      class="p-col-12 rounded whiteBg paddedCol p-my-3 p-text-left"
      style="font-size: 0.8em; border: 1px solid lightgrey"
    >
      <div class="title is-3">
        {{ s.name }}
        <Button
          @click="startDelete(s)"
          :label="`Delete ${s.games.length} Games from SE`"
          class="dsButton p-button-sm p-button-danger floatRight p-ml-2"
        />
      </div>
      <div>Games: {{ s.games.length }}</div>
      <div v-for="g in s.games" :key="g.id">
        <div class="colorBall" v-bind:style="{ background: g.color || '#FFFFFF' }" />
        {{ g.summary }}
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  // ddddd
  data() {
    return {
      schedules: [],
    };
  },
  computed: {},
  methods: {
    startDelete(s) {
      var x = window.confirm(
        "Are you sure? This will delete all " +
          s.games.length +
          " games from SportsEngine. Games will NOT be deleted here in Diamond Scheduler. This cannot be undone.",
      );
      if (x) {
        this.trackEvent("Confirmed SportsEngine Clear", { schedule: s });
        api
          .deleteAllSportsEngine(s.id)
          .then(response => {
            console.log(response);
            this.goRouter(`/activity/${response.data.activity.id}`);
            // this.makeToast(
            //   "success",
            //   "Game clearing in progress!",
            //   "Please allow for up to 15 minutes for full deletion, depending on game count. Don't clear the games again during this time.",
            //   10000
            // );
            this.schedules.splice(this.schedules.indexOf(s), 1);
          })
          .catch(e => {
            this.makeToast("error", "Could clear games: " + e);
          });
      } else {
        this.makeToast("info", "Action cancelled, no games deleted!");
      }
    },
    fetchData() {
      this.isLoading = true;
      api
        .getSESchedules()
        .then(response => {
          console.log(response);
          this.schedules = response.data;
        })
        .catch(e => {
          this.makeToast("error", "Could not fetch schdules");
          this.isLoading = false;
        });
    },
  },
  created() {},
  mounted() {
    this.fetchData();
    window.analytics.page();
    this.trackEvent("Opened SportsEngine Delete", {});
  },
};
</script>

<style scoped lang="scss">
.importHeader {
  margin-top: 10px;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 1.4em;
}
</style>
